import {API_SERVERLESS, getFetch} from '~commonApi';

export function apiBackOfficeGetFormJSONMappings(formId) {
    return getFetch(`${API_SERVERLESS}/backOffice/v3/mappings/${formId}`, true);
}
